import { createContext, useContext } from 'react';
import type { CommandBarTier } from './commandBarLayout';

/**
 * The command bar's measured density tier (see commandBarLayout.ts), provided
 * by CommandBar so its group components (SitrepControls, AssistanceControls,
 * NewsMenu, DroneMenu…) can show/hide captions without prop threading —
 * NewsMenu and DroneMenu are deliberately prop-free.
 *
 * Defaults to 'full' (everything rendered) for any component rendered outside
 * the bar — matching commandBarTierForWidth's unmeasured behavior.
 */
export const CommandBarTierContext = createContext<CommandBarTier>('full');

export function useCommandBarTier(): CommandBarTier {
  return useContext(CommandBarTierContext);
}
